<footer *ngIf="!hideFooter">
  <div class="container">
    <div class="footer-main">
      <div class="footer-middle">
        <div class="footer-middle-item">
          <img src="./assets/images/png/verification.png" alt="verification" />
        </div>

        <div class="footer-middle-item">
          <img src="./assets/images/png/shield.png" alt="shield" />
        </div>

        <div class="footer-middle-item">
          <img src="./assets/images/png/money.png" alt="money" />
        </div>
      </div>

      <div class="footer-top">
        <div class="footer-item">
          <h3>Know Us</h3>

          <ul class="item-link">
            <li>
              <p>
                <span>{{ shopInfo?.siteName }}</span>
              </p>
            </li>
            <li class="address-content">
              <p>
                <span>{{ shopInfo?.shortDescription }}</span>
              </p>
            </li>
            <li class="address-content">
              <i class="fa-solid fa-phone"></i>
              <p>
                <a
                  [href]="'tel:' + data?.value"
                  *ngFor="let data of shopInfo?.phones"
                  >{{ data?.value }}</a
                >
              </p>
            </li>
            <li class="address-content">
              <i class="fa-regular fa-envelope"></i>
              <p>
                <a
                  [href]="'mailto:' + data?.value"
                  *ngFor="let data of shopInfo?.emails"
                  >{{ data?.value }}</a
                >
              </p>
            </li>
            <li class="address-content">
              <i class="fa-solid fa-location-dot"></i>
              <span *ngFor="let data of shopInfo?.addresses">{{
                data.value
              }}</span>
            </li>
            <li>
              <span>Trade License No: {{ shopInfo?.tradLicense }}</span>
            </li>
          </ul>
        </div>

        <div class="footer-item">
          <h3>Our Policies</h3>
          <ul class="item-link">
            <li>
              <a href="/pages/privacy-policy" routerLink="/pages/privacy-policy"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a
                href="/pages/terms-and-conditions"
                routerLink="/pages/terms-and-conditions"
                >Terms and Conditions</a
              >
            </li>
            <li>
              <a
                href="/pages/delivery-policy"
                routerLink="/pages/delivery-policy"
                >Delivery Policy</a
              >
            </li>
            <li>
              <a
                href="/pages/return-&-refund-policy"
                routerLink="/pages/return-&-refund-policy"
                >Refund, Return & Exchange Policy</a
              >
            </li>
            <li>
              <a href="/pages/disclaimer" routerLink="/pages/disclaimer"
                >Disclaimer</a
              >
            </li>
            <li><a href="/pages/faq" routerLink="/pages/faq">FAQ</a></li>
          </ul>
        </div>

        <div class="footer-item">
          <h3>Our Services</h3>
          <ul class="item-link">
            <li>
              <a href="/pages/about-us" routerLink="/pages/about-us"
                >About Us</a
              >
            </li>
            <li>
              <a href="/contact-us" routerLink="/contact-us">Contact Us</a>
            </li>
            <li><a href="/" routerLink="/">Home</a></li>
            <li>
              <a href="/product-list" routerLink="/product-list">Products</a>
            </li>
            <li><a href="/blogs" routerLink="/blogs">Blog</a></li>
            <li>
              <a href="/coming-soon" routerLink="/coming-soon">Online Doctor</a>
            </li>
            <li>
              <a href="/coming-soon" routerLink="/coming-soon"
                >Online Diagnosis</a
              >
            </li>
          </ul>
        </div>

        <div
          class="footer-item"
          *ngIf="shopInfo?.socialLinks && shopInfo?.socialLinks.length >= 4"
        >
          <h3 class="social-media-connect">Connect</h3>

          <div class="social-media">
            <p>Social Media Links</p>
            <ul>
              <li>
                <a
                  class="facebook"
                  [href]="shopInfo?.socialLinks[0]?.value"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a
                  class="twitter"
                  [href]="shopInfo?.socialLinks[1]?.value"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a
                  class="linkedin-in"
                  [href]="shopInfo?.socialLinks[2]?.value"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li>
                <a
                  class="youtube"
                  [href]="shopInfo?.socialLinks[3]?.value"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          class="footer-item"
          *ngIf="shopInfo?.downloadUrls && shopInfo?.downloadUrls.length >= 2"
        >
          <h3 class="social-media-connect">Download Apps</h3>

          <div class="apps-link">
            <ul>
              <li>
                <a
                  [href]="shopInfo?.downloadUrls[0]?.value"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    src="./assets/images/png/playstore-app.png"
                    alt="Get Quick Pharma on Google Play"
                  />
                </a>
              </li>

              <li>
                <a
                  [href]="shopInfo?.downloadUrls[1]?.value"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    src="./assets/images/png/app-store-app.png"
                    alt="Download Quick Pharma on Apple App Store"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <img src="./assets/images/webp/ssl.webp" alt="SSL Secured Payment" />
      </div>
    </div>
  </div>
</footer>

<div class="footer-bottom-copyright" *ngIf="!hideFooter">
  <div class="container">
    <div class="footer-bottom-copyright-main">
      <h3>
        Copyright © {{ dateData.getFullYear() }} Quick Pharma - All Rights
        Reserved
      </h3>
    </div>
  </div>
</div>
